(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["temporizador-seccion"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initBar(bar) {
      if (bar.dataset.tsInit === 'true') return;
      bar.dataset.tsInit = 'true';
      var modo = bar.dataset.modo;
      var accion = bar.dataset.accion;
      var elDays  = bar.querySelector('[data-days]');
      var elHours = bar.querySelector('[data-hours]');
      var elMins  = bar.querySelector('[data-mins]');
      var elSecs  = bar.querySelector('[data-secs]');
      var targetTime, intervalId;

      function calcularTarget() {
        if (modo === 'fecha_fija') {
          var parsed = new Date(bar.dataset.fechaTarget).getTime();
          return isNaN(parsed) ? Date.now() : parsed;
        }
        var key = bar.dataset.storageKey;
        var dur = parseInt(bar.dataset.duracionMs, 10) || 86400000;
        var stored = null;
        try { stored = localStorage.getItem(key); } catch(e) {}
        if (stored && parseInt(stored, 10) > Date.now()) return parseInt(stored, 10);
        var nuevo = Date.now() + dur;
        try { localStorage.setItem(key, String(nuevo)); } catch(e) {}
        return nuevo;
      }

      function pintar(diff) {
        if (diff < 0) diff = 0;
        if (elDays)  elDays.textContent  = String(Math.floor(diff / 86400000)).padStart(2,'0');
        if (elHours) elHours.textContent = String(Math.floor((diff % 86400000) / 3600000)).padStart(2,'0');
        if (elMins)  elMins.textContent  = String(Math.floor((diff % 3600000) / 60000)).padStart(2,'0');
        if (elSecs)  elSecs.textContent  = String(Math.floor((diff % 60000) / 1000)).padStart(2,'0');
      }

      function expirar() {
        if (accion === 'ocultar') { bar.style.display = 'none'; }
        else if (accion === 'reiniciar' && modo === 'evergreen') {
          var dur = parseInt(bar.dataset.duracionMs, 10) || 86400000;
          targetTime = Date.now() + dur;
          try { localStorage.setItem(bar.dataset.storageKey, String(targetTime)); } catch(e) {}
          return false;
        } else { pintar(0); }
        clearInterval(intervalId);
        return true;
      }

      function tick() {
        var diff = targetTime - Date.now();
        if (diff <= 0) { if (expirar()) return; }
        pintar(targetTime - Date.now());
      }

      try {
        targetTime = calcularTarget();
        tick();
        intervalId = setInterval(tick, 1000);
      } catch(e) { console.error('Temporizador error:', e); }
    }

    function initAll(root) {
      (root || document).querySelectorAll('[data-ts-bar]').forEach(initBar);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function(){ initAll(); });
    } else { initAll(); }

    document.addEventListener('shopify:section:load',   function(e){ initAll(e.target); });
    document.addEventListener('shopify:section:select', function(e){ initAll(e.target); });
  })();

  } catch(e) { console.error(e); }
})();
})();
